export enum OpportunitySolutionTagTypeEnum {
  NONE = 'None',
  CATEGORY = 'Category',
  NAME = 'Name',
}
